const $ = require('jquery');

const nestedLink = function() {
	$('.js-link').click(function(e){
		e.preventDefault();
		var $href = $(this).attr('href');
		window.location.href = $href;
	});
};

module.exports = nestedLink;
